import React from 'react';

/**
 * Official Google Ads mark supplied for Mora's integration directory. Keep the
 * asset raster-native rather than redrawing or tinting it: Google Ads' three
 * colour geometry is part of the product identifier.
 */
export const GoogleAdsIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ className, ...props }) => (
  <img
    src="/icons/google-ads-144.png"
    alt=""
    className={className}
    {...(props as React.ImgHTMLAttributes<HTMLImageElement>)}
  />
);
